import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  overFilteredTimeStamp: null,
  hasExpressDeal: false,
  setAttributeText: false,
  isFiltersAppliedForGa: false,
}

export const flags = createSlice({
  name: 'flags',
  initialState,
  reducers: {
    setHasExpressDeal: (state, action) => {
      state.hasExpressDeal = action.payload
    },
    setOverfilteredStatus: (state, action) => {
      state.overFilteredTimeStamp = action.payload
    },
    setOverfilteredBannerText: (state, action) => {
      state.setAttributeText = action.payload
    },
    setIsFiltersAppliedForGa: (state, action) => {
      state.isFiltersAppliedForGa = action.payload
    },
  },
})

export const {
  setHasExpressDeal,
  setOverfilteredStatus,
  setOverfilteredBannerText,
  setIsFiltersAppliedForGa,
} = flags.actions
